// extracted by mini-css-extract-plugin
export var bodySections = "_d2-8";
export var gray = "_d2-7";
export var green = "_d2-4";
export var iconContainer = "_d2-9";
export var iconWidgetContainer = "_d2-1";
export var phoneIcon = "_d2-2";
export var red = "_d2-5";
export var statusDot = "_d2-3";
export var widgetContainer = "_d2-0";
export var yellow = "_d2-6";